module.exports = __webpack_public_path__ + "static/payday-2-vr-vive-8e02fe33b3c352ecdcb85758448349ea.jpg";